import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import PosterCard from "../cards/PosterCard";
import "./PosterRow.css";

function PosterRow({
  title,
  fetchData = [],
  type,
  viewAllLink,
  large = false,
  autoplay = false,
  onCardClick, // ✅ ADD THIS
}) {
  const rowRef = useRef(null);
  const intervalRef = useRef(null);
  const navigate = useNavigate();

  /* ================= AUTO SCROLL ================= */
  useEffect(() => {
    if (!autoplay) return;

    intervalRef.current = setInterval(() => {
      if (!rowRef.current) return;

      rowRef.current.scrollBy({
        left: large ? 500 : 320,
        behavior: "smooth",
      });
    }, 3000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [autoplay, large]);

  const stopAutoScroll = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const startAutoScroll = () => {
    if (!autoplay || intervalRef.current) return;

    intervalRef.current = setInterval(() => {
      if (!rowRef.current) return;

      rowRef.current.scrollBy({
        left: large ? 500 : 320,
        behavior: "smooth",
      });
    }, 3000);
  };

  const scrollLeft = () => {
    if (!rowRef.current) return;
    rowRef.current.scrollBy({
      left: -(large ? 500 : 320),
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    if (!rowRef.current) return;
    rowRef.current.scrollBy({
      left: large ? 500 : 320,
      behavior: "smooth",
    });
  };

  /* ================= RENDER ================= */
  if (!fetchData || fetchData.length === 0) return null;

  return (
    <section className="poster-row">
      {/* HEADER */}
      <div className="poster-row-header">
        <h2>{title}</h2>

        {viewAllLink && (
          <span className="view-all" onClick={() => navigate(viewAllLink)}>
            View All →
          </span>
        )}
      </div>

      {/* SLIDER WRAPPER */}
      <div className="poster-row-wrapper">
        {/* LEFT ARROW */}
        <button className="scroll-arrow left" onClick={scrollLeft}>
          ❮
        </button>

        {/* SLIDER */}
        <div
          className={`poster-row-slider ${large ? "large" : ""} mobile-single`}
          ref={rowRef}
          onMouseEnter={stopAutoScroll}
          onMouseLeave={startAutoScroll}
          onTouchStart={stopAutoScroll}
          onTouchEnd={startAutoScroll}
        >
          {fetchData.map((item) => (
  <PosterCard
    key={item.id}
    item={item}
    type={type}
    large={large}
    onClick={onCardClick}   // ✅ ADD THIS
  />
))}
        </div>

        {/* RIGHT ARROW */}
        <button className="scroll-arrow right" onClick={scrollRight}>
          ❯
        </button>
      </div>
    </section>
  );
}

export default PosterRow;
